import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)


/* Layout */
import Layout from '@/pages/layout/layout'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [{
        path: '/login',
        component: () => import('../pages/login/login'),
        hidden: true
    },

    {
        path: '/404',
        component: () => import('../pages/error/index'),
        hidden: true
    },

]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [

    {
        path: '/',
        component: Layout,
        redirect: '/index',
        children: [{
            name: 'index',
            title: '首页',
            path: '/index',
            component: () => import('../pages/home/home'),
            meta: {
                title: '首页',
                icon: 'el-icon-s-home'
            }
        }, ]
    },
    {
        path: '/monitor',
        name: 'monitor',
        meta: {
            title: '远程监控',
            icon: 'el-icon-s-claim',
            roles: ['admin']
        },
        component: Layout,
        children: [{
                path: 'single',
                name: 'single',
                meta: {
                    title: '单梯监控',
                    icon: 'el-icon-tickets',
                    roles: ['admin']
                },
                component: () => import('../pages/monitor/single')
            },
            {
                path: 'multiple',
                name: '多梯监控',
                meta: {
                    title: '多梯监控',
                    icon: 'el-icon-bangzhu',
                    roles: ['admin']
                },
                component: () => import('../pages/monitor/multiple')
            },
            {
                path: 'animation',
                name: '动画展示',
                meta: {
                    title: '动画展示',
                    icon: 'el-icon-set-up',
                    roles: ['admin']
                },
                component: () => import('../pages/monitor/animation')
            },
        ]
    },
	
	
    {
        path: '/repair',
        name: '故障监测',
        meta: {
            title: '故障监测',
            icon: 'el-icon-data-analysis',
            roles: ['admin']
        },
        component: Layout,
        children: [{
            path: 'index',
            name: '故障监测',
            meta: {
                title: '故障监测',
                icon: 'el-icon-suitcase',
                roles: ['admin']
            },
            component: () => import('../pages/repair/index')
        }]
    },
    {
        path: '/uncivilized',
        name: '不文明行为',
        meta: {
            title: '不文明行为',
            icon: 'el-icon-school',
            roles: ['admin']
        },
        component: Layout,
        children: [{
            path: 'index',
            name: '不文明行为',
            meta: {
                title: '不文明行为',
                icon: 'el-icon-sell',
                roles: ['admin']
            },
            component: () => import('../pages/uncivilized/index')
        }]
    },
    {
        path: '/move',
        name: '运行统计',
        meta: {
            title: '运行统计',
            icon: 'el-icon-discount',
            roles: ['admin']
        },
        component: Layout,
        children: [{
            path: 'index',
            name: '运行统计',
            meta: {
                title: '运行统计',
                icon: 'el-icon-postcard',
                roles: ['admin']
            },
            component: () => import('../pages/move/index')
        }]
    },
    {
        path: '/Statistics',
        name: '统计分析',
        title: '统计分析',
        meta: {
            title: '统计分析',
            icon: 'el-icon-full-screen',
            roles: ['admin']
        },
        component: Layout,
        children: [{
                path: 'fault',
                name: 'fault',
                meta: {
                    title: '故障统计',
                    icon: 'el-icon-wind-power',
                    roles: ['admin']
                },
                component: () => import('../pages/Statistics/fault')
            },
            {
                path: 'uncivilized',
                name: '不文明行文',
                meta: {
                    title: '不文明行为',
                    icon: 'el-icon-coffee',
                    roles: ['admin']
                },
                component: () => import('../pages/Statistics/uncivilized')
            },
            {
                path: 'move',
                name: '运行数据统计',
                meta: {
                    title: '运行数据统计',
                    icon: 'el-icon-receiving',
                    roles: ['admin']
                },
                component: () => import('../pages/Statistics/move')
            },
            {
                path: 'history',
                name: '历史走势图',
                meta: {
                    title: '历史走势图',
                    icon: 'el-icon-coordinate',
                    roles: ['admin']
                },
                component: () => import('../pages/Statistics/history')
            },
   //          {
   //              path: 'peopleFlow',
   //              name: '单梯人流量',
   //              meta: {
   //                  title: '单梯人流量',
   //                  icon: 'el-icon-coordinate',
   //                  roles: ['admin']
   //              },
   //              component: () => import('../pages/Statistics/people-flow')
   //          },
   //              {
   //              path: 'floorPeopleFlow',
   //              name: '楼层人流量',
   //              meta: {
   //                  title: '楼层人流量',
   //                  icon: 'el-icon-coordinate',
   //                  roles: ['admin']
   //              },
   //              component: () => import('../pages/Statistics/floor-people-flow')
   //          },
			// {
			//     path: 'villagePeopleFlow',
			//     name: '小区人流量',
			//     meta: {
			//         title: '小区人流量',
			//         icon: 'el-icon-coordinate',
			//         roles: ['admin']
			//     },
			//     component: () => import('../pages/Statistics/village-people-flow')
			// },
		
        ]
    },
 //    {
	//     path: '/',
	//     name: 'maintenance',
	//     meta: {
	//         title: '维保信息',
	//         icon: 'el-icon-headset',
	//         roles: ['admin']
	//     },
	//     component: Layout,
	//     children: [{
 //            path: '/maintenance/index',
 //            name: '维保工单',
 //            meta: {
 //                title: '维保工单',
 //                icon: 'el-icon-headset',
 //                roles: ['admin']
 //            },
 //            component: () => import('../pages/maintenance/order/index')
 //        },{
 //            path: '/repair-order/index',
 //            name: '维修工单',
 //            meta: {
 //                title: '维修工单',
 //                icon: 'el-icon-headset',
 //                roles: ['admin']
 //            },
 //            component: () => import('../pages/maintenance/repair/index')
 //        },{
 //            path: '/rescue/index',
 //            name: '急救工单',
 //            meta: {
 //                title: '急救工单',
 //                icon: 'el-icon-headset',
 //                roles: ['admin']
 //            },
 //            component: () => import('../pages/maintenance/rescue/index')
 //        },
	//     ]
	// },

    // 404 page must be placed at the end !!!
    {
        path: '*',
        redirect: '/404',
        hidden: true
    }
]

const createRouter = () => new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
})

const router = createRouter()
// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // reset router
}

export default router